import React from 'react';

import { FullPageBox } from '../../components/full-page-box/full-page-box';
import { PasswordResetForm } from '../../components/password-reset-form/password-reset-form';

const PasswordReset = () => (
  <FullPageBox width="400px">
    <PasswordResetForm />
  </FullPageBox>
);

export { PasswordReset };
